import React from "react";
import {formatCurrency} from "../../utils/Utils";

// Clamp a value into [0,100] percentage along [lo,hi].
const pct = (v, lo, hi) => {
    if (v === undefined || lo === undefined || hi === undefined || hi === lo) return 0;
    return Math.max(0, Math.min(100, ((v - lo) / (hi - lo)) * 100));
};

// Competitive/DS: axis from min..max of in-stock competitors, my marker on it.
// Brand: axis is the allowed MAP..MRP range (green) over a red out-of-range track.
const PriceRangeBand = (props) => {
    const { t } = props;
    const { type, stats, mapValue, mrpValue } = props;

    if (type === 'allowed-band') {
        // Allowed range = [map, mrp]; axis spans a little beyond both for context.
        const lo = mapValue, hi = mrpValue;
        if (lo === undefined && hi === undefined)
            return <div className="pux-empty">{t('product_detail.no_map_mrp', 'MAP/MRP not set')}</div>;
        const axisLo = (lo !== undefined ? lo : hi) * 0.9;
        const axisHi = (hi !== undefined ? hi : lo) * 1.1;
        return <div className="pux-allowed" style={{margin:'26px 0 10px'}}>
            {lo !== undefined && hi !== undefined &&
                <div className="pux-allowed-ok" style={{left: pct(lo, axisLo, axisHi) + '%', right: (100 - pct(hi, axisLo, axisHi)) + '%'}}/>}
            {lo !== undefined && <span className="pux-range-cap left">MAP {formatCurrency(lo, stats.currency)}</span>}
            {hi !== undefined && <span className="pux-range-cap right">MRP {formatCurrency(hi, stats.currency)}</span>}
        </div>;
    }

    // price-band
    const { myPrice, minPrice, avgPrice, maxPrice, currency } = stats;
    if (minPrice === undefined)
        return <div className="pux-empty">{t('product_detail.no_competitor_price', 'No in-stock competitor price')}</div>;

    const lo = Math.min(minPrice, myPrice !== undefined ? myPrice : minPrice);
    const hi = Math.max(maxPrice, myPrice !== undefined ? myPrice : maxPrice);
    const mineLeft = pct(myPrice, lo, hi);
    // Single competitor (or every competitor at the same price): one marker + one caption,
    // otherwise min/avg/max stack on the same spot and overlap.
    const single = minPrice === maxPrice;
    // Keep a centered caption from spilling past the bar ends: left-align it near
    // the start, right-align near the end, centered in between.
    const capTransform = (p) => p <= 12 ? 'translateX(0)' : (p >= 88 ? 'translateX(-100%)' : 'translateX(-50%)');
    const avgLeft = avgPrice !== undefined ? pct(avgPrice, lo, hi) : 0;

    // Bar shows only the prices; the description (cheapest / average / highest) is a
    // hover tooltip. Only my own marker carries the "You" label.
    return <div className="pux-range">
        {!single && <div className="pux-range-fill" style={{left: pct(minPrice, lo, hi) + '%', right: (100 - pct(maxPrice, lo, hi)) + '%'}}/>}
        {single
            ? <div className="pux-range-avg" style={{left: pct(minPrice, lo, hi) + '%'}} title={t('product_detail.competitors')}/>
            : (avgPrice !== undefined && <div className="pux-range-avg" style={{left: pct(avgPrice, lo, hi) + '%'}} title={t('product_detail.kpi_avg_of_comp')}/>)}
        {myPrice !== undefined && <>
            <div className="pux-range-mine" style={{left: mineLeft + '%'}}/>
            <span className="pux-range-mine-cap" style={{left: mineLeft + '%', transform: capTransform(mineLeft)}}>
                {t('product_detail.you', 'You')} {formatCurrency(myPrice, currency)}
            </span>
        </>}
        {single
            ? <span className={"pux-range-cap " + (myPrice !== undefined && myPrice > minPrice ? 'left' : 'right')} title={t('product_detail.competitors')}>{formatCurrency(minPrice, currency)}</span>
            : <>
                <span className="pux-range-cap left" title={t('product_detail.kpi_min_of_comp')}>{formatCurrency(minPrice, currency)}</span>
                {avgPrice !== undefined && <span className="pux-range-cap mid" style={{left: avgLeft + '%', transform: capTransform(avgLeft)}} title={t('product_detail.kpi_avg_of_comp')}>{formatCurrency(avgPrice, currency)}</span>}
                <span className="pux-range-cap right" title={t('product_detail.kpi_max_of_comp')}>{formatCurrency(maxPrice, currency)}</span>
              </>}
    </div>;
};
export default PriceRangeBand;
